import React from 'react';
import unpick from '../../utilities/unpick';

export default function Dropdown(props) {
  const { isValid, innerRef } = props;
  let sp = unpick(props, ['options', 'placeholder', 'defaultValue', 'ariaLabel', 'isValid', 'innerRef']);
  let options = props.options || [];
  return (
    <select
      {...sp}
      value={props.value || ''}
      aria-label={sp.ariaLabel || 'Select options'}
      aria-invalid={!isValid}
      ref={innerRef}
    >
      <option value="" disabled>
        {props.placeholder || '---'}
      </option>
      {options.map((o) => (
        <option key={o.key || o.value} value={o.value}>
          {o.text}
        </option>
      ))}
    </select>
  );
}

Dropdown.propTypes = {};
